import SectionHeading from "./SectionHeading";
import { downloadTiers, qualityNotes } from "@/mocks/anime";

const accentStyles: Record<string, string> = {
  primary: "border-primary-200 bg-primary-50",
  accent: "border-accent-300 bg-accent-50",
  secondary: "border-secondary-200 bg-secondary-50",
};

const badgeStyles: Record<string, string> = {
  primary: "bg-primary-500 text-background-50",
  accent: "bg-accent-500 text-accent-950",
  secondary: "bg-secondary-500 text-background-50",
};

export default function DownloadSection() {
  return (
    <section id="download" className="w-full bg-background-50 px-4 py-14 md:px-8 md:py-20">
      <SectionHeading
        eyebrow="离线收藏与投屏"
        title="高清资源下载专区"
        desc="同一部作品提供多种规格，按设备与用途选择：手机平板离线选轻量档，大屏投屏选高画质档，想一次补齐整季则用打包合集。以下体积与编码为示例说明。"
      />

      <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-3">
        {downloadTiers.map((tier) => (
          <div
            key={tier.id}
            className={`flex flex-col rounded-lg border p-5 ${accentStyles[tier.accent]}`}
          >
            <div className="flex items-center justify-between">
              <span
                className={`rounded-full px-2.5 py-0.5 text-[11px] font-medium ${badgeStyles[tier.accent]}`}
              >
                {tier.resolution}
              </span>
              <i className="ri-hard-drive-2-line text-xl text-foreground-400" />
            </div>
            <h3 className="mt-4 font-heading text-2xl text-foreground-950">{tier.name}</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">{tier.desc}</p>

            <dl className="mt-4 space-y-2 border-t border-foreground-950/10 pt-4 text-sm">
              <div className="flex items-center justify-between">
                <dt className="text-foreground-500">分辨率</dt>
                <dd className="text-foreground-800">{tier.resolution}</dd>
              </div>
              <div className="flex items-center justify-between">
                <dt className="text-foreground-500">编码 / 音轨</dt>
                <dd className="text-foreground-800">{tier.codec}</dd>
              </div>
              <div className="flex items-center justify-between">
                <dt className="text-foreground-500">文件体积</dt>
                <dd className="text-foreground-800">{tier.size}</dd>
              </div>
            </dl>

            <span className="mt-5 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2.5 text-sm text-background-50">
              <i className="ri-download-cloud-2-line" />
              选择该规格下载
            </span>
          </div>
        ))}
      </div>

      <div className="mt-6 grid grid-cols-1 gap-5 rounded-lg border border-background-200 bg-background-100 p-5 md:grid-cols-3 md:p-6">
        {qualityNotes.map((note) => (
          <div key={note.title} className="flex gap-3.5">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
              <i className={`${note.icon} text-xl`} />
            </span>
            <div>
              <h3 className="font-heading text-lg text-foreground-950">{note.title}</h3>
              <p className="mt-1 text-sm leading-relaxed text-foreground-600">{note.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}